<template>
  <v-dialog @keydown.esc="closeDialog" v-model="isOpen" persistent max-width="400px">
    <v-card>
      <v-card-title>
        <span>{{ item.wPrice ? 'Editar' : 'Agregar' }} Precio Sugerido</span>
      </v-card-title>
      <v-card-text>
        <v-col>
          <div><b>{{ item.name ? item.name.toUpperCase() : '' }}</b></div>
          <div v-if="item.wPrice">Precio sugerido actual: <b>${{ item.wPrice.toFixed(2) | numberWithComma }} </b></div>
          <div v-if="item.wPrice">Porcentaje de costo actual: <b>{{ item.cost | percentOf(item.wPrice) | toFixNumber }}% </b></div>
        </v-col>
        <v-form ref="priceForm" v-model="isFormValid">
          <v-container grid-list-xl>
            <v-layout wrap>
              <v-flex >
                <v-text-field
                  v-model="suggestedPrice"
                  prefix="$"
                  :rules="validation.suggestedPrice"
                ></v-text-field>
              <div v-if="suggestedPrice && isFormValid" style="font-size: 14px">Nuevo porcentaje de costo: <b>{{ (item.cost / suggestedPrice * 100).toFixed(2) }}% </b></div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="error"
          class="mr-2"
          rounded
          small
          @click="closeDialog('close')"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="success"
          class="mr-4"
          rounded
          small
          @click="submit"
          :disabled="!isFormValid"
        >
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script>
import { numeric, required } from 'vue-mc/validation'

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      overlay: false,
      isOpen: false,
      suggestedPrice: '',
      isInputValid: false,
      isFormValid: false,
      validation: {
        suggestedPrice: [required.and(numeric), (value) => value > 0 || 'Price must be greater than zero']
      }
    }
  },
  watch: {
    isOpen (val) {
      if (val) {
        this.resetPriceForm()
      }
    }
  },
  methods: {
    closeDialog (event) {
      this.isOpen = false
      this.$emit(event)
    },
    async submit () {
      if (!this.isFormValid) return
      this.overlay = true
      try {
        const suggestedPriceNumber = parseFloat(this.suggestedPrice)
        const payload = { wPrice: suggestedPriceNumber }

        if (typeof (payload.section) !== 'string' && payload.subrecipe === false) payload.section = payload.section._id
        await this.$api.put(`/v1/recipes/${this.item.uuid}`, payload)

        this.$toasted.show('Receta actualizada', { duration: 3500, type: 'success', position: 'top-center', iconPack: 'mdi', icon: 'mdi-check-circle' })
        this.closeDialog('submit')
      } catch (error) {
        this.$toasted.show(
          error.message,
          { duration: 3500, type: 'error', position: 'top-center', iconPack: 'mdi', icon: 'mdi-cancel' }
        )
      }
      this.overlay = false
    },
    open () {
      this.isOpen = true
    },
    resetPriceForm () {
      this.suggestedPrice = ''
      this.isInputValid = false
      this.isFormValid = false
    }
  }
}
</script>
